import React, { useState, useEffect } from "react";
import NavArrows from "../NavArrows/NavArrows";
import styled from "styled-components";
const PageNavigator = ({ currentIndex, leftArrowAction, rightArrowAction, setNewSelectionIndex, title, totalPages, labelClassName, }) => {
    // track the value of the index input
    const [indexInputValue, setIndexInputValue] = useState(currentIndex ? currentIndex + 1 : undefined);
    useEffect(() => {
        // if the buttons are clicked, we want to properly update the input
        if (currentIndex == undefined)
            setIndexInputValue(0);
        else if (currentIndex + 1 !== indexInputValue)
            setIndexInputValue(currentIndex + 1);
    }, [currentIndex]);
    const fallbackLeftArrowAction = () => {
        // will subtract 1 from currentIndex and pass that index to the setNewSelectionIndex method
        // will not allow user to go beyond 0
        const newIndex = currentIndex != undefined && currentIndex > 0 ? currentIndex - 1 : 0;
        setNewSelectionIndex(newIndex);
    };
    const fallbackRightArrowAction = () => {
        // will add 1 to currentIndex and pass that index to the setNewSelectionIndex method
        // will not allow user to exceed the total number of pages
        const newIndex = currentIndex != undefined && currentIndex < totalPages - 1 ? currentIndex + 1 : totalPages - 1;
        setNewSelectionIndex(newIndex);
    };
    const isValidInput = (value) => {
        return !!value && typeof value === "string" && !Number.isNaN(parseInt(value));
    };
    const handleIndexInputUpdate = (event) => {
        const value = event?.currentTarget?.value;
        const newIndex = isValidInput(value) ? parseInt(value) : undefined;
        setIndexInputValue(newIndex);
    };
    const getIndexFromInput = (value) => {
        // only set the index if the input value is all numbers
        return value != undefined && isValidInput(value) ? parseInt(value) - 1 : undefined;
    };
    const handleKeyDown = (event) => {
        if (event?.key === "Enter") {
            handleOnBlur(event);
        }
    };
    const handleOnBlur = (event) => {
        const newIndex = getIndexFromInput(event?.currentTarget?.value);
        setNewSelectionIndex(newIndex);
    };
    return (React.createElement(NavContainer, null,
        React.createElement("label", { className: `${labelClassName ?? ""} nav-description` }, `${title}${indexInputValue ? "," : ""}`),
        React.createElement(React.Fragment, null,
            React.createElement("input", { value: indexInputValue ? indexInputValue : 0, onBlur: handleOnBlur, onChange: handleIndexInputUpdate, className: "nav-description nav-input", onKeyDown: handleKeyDown }),
            React.createElement("label", { className: `${labelClassName ?? ""} nav-description` }, `of ${totalPages}`)),
        React.createElement(NavArrows, { className: "nav-arrows", leftAction: leftArrowAction ?? fallbackLeftArrowAction, rightAction: rightArrowAction ?? fallbackRightArrowAction })));
};
const NavContainer = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right: 8px;

    .nav-description {
        margin-bottom: 0;
        font-size: 14px;
        font-weight: 400;
        color: @color-functional-gray70;
    }

    .nav-input {
        width: 40px;
        margin-right: 8px;
        margin-left: 8px;
    }

    .nav-arrows {
        margin-left: 8px;
    }
`;
export default PageNavigator;
